import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { PrimaryButton, DefaultButton, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { toggleConnectGmailWindow } from '../actions/connectGmail/toggleConnectGmailWindow';
import { updateGmailDisplayName } from '../actions/connectGmail/updateGmailDisplayName';
import { updateGmailIsSendOnly } from '../actions/connectGmail/updateGmailIsSendOnly';
import { updateGmailTargetRootFolderEnabled } from '../actions/connectGmail/updateGmailTargetRootFolderEnabled';
import { connectedAccountsStore } from '../store/store';
import { connectGmail } from '../utils/connectGmail';
import strings from 'owa-strings/owa-options-strings';
var styles = require('./ConnectGmailWindow.scss');
var ConnectGmailWindow = /** @class */ (function (_super) {
    tslib_1.__extends(ConnectGmailWindow, _super);
    function ConnectGmailWindow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            toggleConnectGmailWindow({ connectGmailOpen: false });
        };
        _this.onConnectGroupSelected = function (ev, option) {
            var isSendOnly = option.key == 'SendOnly';
            updateGmailIsSendOnly(isSendOnly);
        };
        _this.onStorageSelected = function (ev, option) {
            var targetRootFolderEnabled = option.key == 'NewFolder';
            updateGmailTargetRootFolderEnabled(targetRootFolderEnabled);
        };
        return _this;
    }
    ConnectGmailWindow.prototype.render = function () {
        var store = connectedAccountsStore();
        return (React.createElement(Dialog, { hidden: !store.dialogWindowState.connectGmailOpen, dialogContentProps: {
                type: DialogType.normal,
                title: strings.options_connected_gmail_title,
            }, modalProps: {
                isBlocking: true,
                containerClassName: styles.dialog,
                onDismiss: this.onClose,
            } },
            React.createElement(TextField, { label: strings.options_connected_gmail_displayNameTextField, onChanged: updateGmailDisplayName, disabled: store.connectGmailState.isConnecting }),
            React.createElement(ChoiceGroup, { options: [
                    {
                        key: 'Connected',
                        text: strings.options_connected_gmail_connectedOption,
                        checked: !store.connectGmailState.isSendOnly,
                    },
                    {
                        key: 'SendOnly',
                        text: strings.options_connected_gmail_sendOnlyOption,
                        checked: store.connectGmailState.isSendOnly,
                    },
                ], required: true, onChange: this.onConnectGroupSelected, className: styles.marginTop, disabled: store.connectGmailState.isConnecting }),
            !store.connectGmailState.isSendOnly && (React.createElement(ChoiceGroup, { options: [
                    {
                        key: 'NewFolder',
                        text: strings.options_connected_gmail_newFolderOption,
                        checked: store.connectGmailState.targetRootFolderEnabled,
                    },
                    {
                        key: 'ExistingFolder',
                        text: strings.options_connected_gmail_existingFolderOption,
                        checked: !store.connectGmailState.targetRootFolderEnabled,
                    },
                ], required: true, onChange: this.onStorageSelected, label: strings.options_connected_gmail_targetOptionLabel, className: styles.marginTop, disabled: store.connectGmailState.isConnecting })),
            React.createElement(Label, { className: styles.marginTop }, strings.options_connected_gmail_connectLabel),
            React.createElement(DialogFooter, null,
                store.connectGmailState.isConnecting && (React.createElement(Spinner, { size: SpinnerSize.large, className: styles.spinner })),
                React.createElement(PrimaryButton, { buttonType: ButtonType.primary, onClick: connectGmail, disabled: store.connectGmailState.isConnecting }, strings.options_connected_okButton),
                React.createElement(DefaultButton, { onClick: this.onClose, disabled: store.connectGmailState.isConnecting }, strings.options_connected_cancelButton))));
    };
    ConnectGmailWindow = tslib_1.__decorate([
        observer
    ], ConnectGmailWindow);
    return ConnectGmailWindow;
}(React.Component));
export default ConnectGmailWindow;
//# sourceMappingURL=ConnectGmailWindow.js.map